import React from "react";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { Box } from "@mui/material";
const SourcesLink = ({ link }) => {
  return (
    <Box display={"flex"} alignItems={"center"} gap={"8px"} marginTop={'30px'}>
      <span style={{ fontSize: "8px", color: "#005AAF" }}>
        <FiberManualRecordIcon fontSize="10px" />
      </span>{" "}
      <a
        href={link}
        style={{
          color: "#005AAF",
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 1, // Limit to 2 lines
          overflow: "hidden",
          textOverflow: "ellipsis",
          width: "80%",
        }}
        // style={{ }}
      >
        {link}
      </a>
    </Box>
  );
};

export default SourcesLink;
